module.exports = __webpack_public_path__ + "static/media/IA.df59af9d.png";